function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M39.756 19.582c-.26.52-.723 1.243-1.15 1.669H4.31c-.249-.343-.841-1.113-1.102-1.67h36.549zm-2.56 3.41a5.526 5.526 0 01-1.754 1.538H7.355c-.557-.379-1.114-.947-1.635-1.539h31.476zm-3.887 3.16c-3.034 2.262-6.364 3.41-8.888 3.576 0-.936 0-2.214.26-3.576h8.628zm9.647-17.746c.26 2.77-.64 6.144-2.347 9.554H27.976c.462-.805 1.066-1.575 1.742-2.356 3.674-4.286 9.315-6.95 13.238-7.198zM18.448 29.74c-2.43-.166-5.772-1.315-8.83-3.576h8.711c.166 1.35.166 2.64.119 3.575zm3.034.26c-.984-.935-1.837-2.214-2.726-3.836h5.416c-.854 1.61-1.79 2.9-2.69 3.836zm-6.447-12.04H2.354C.635 14.55-.206 11.176.043 8.406c3.887.248 9.576 2.9 13.25 7.198.628.781 1.268 1.55 1.742 2.356zm11.91 0H16.006c-.166-.983-.166-1.918-.166-3.031C15.84 8.95 18.483 2.77 21.47 0c2.95 2.77 5.64 8.962 5.64 14.929.013 1.113-.082 2.06-.165 3.03z",
  fill: "#1A1A1A"
});

function SvgAdidasinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 30,
    viewBox: "0 0 43 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgAdidasinline;